<template>
  <div>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">缴费记录查询</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="车牌号" prop="CarNo">
            <el-input v-model="CarNo" placeholder="请输入车牌号"></el-input>
          </el-form-item>
          <el-form-item label="缴费时间" prop="date">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:60rem;"
              unlink-panels
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="carNumber" label="车牌号"></el-table-column>
              <el-table-column prop="parkName" label="停车场"></el-table-column>
              <el-table-column prop="cost" label="缴费金额(元)" width="110"></el-table-column>
              <el-table-column prop="chargeRuleName" label="收费规则"></el-table-column>
              <el-table-column prop="entranceName" label="出入口"></el-table-column>
              <el-table-column prop="dataTime" label="缴费时间" width="160" :formatter="formatDate"></el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import { CarParkFeeRecord } from "@/api/src/entityBaseAllInfo";
export default {
  name: "CarParkFeeRecordView",
  controller: "UI",
  action: "CarParkFeeRecordView",
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      CarNo: "",
      date: [new Date(), new Date()]
    };
  },
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "缴费记录查询";
    this.logInfo.LogMessage = "缴费记录查询";
    this.logInfo.ModuleName = "停车场系统";
    this.logInfo.PageName = "缴费记录查询列表";
    this.addOperationLog();
  },
  methods: {
    search() {
      let searchInfo = {
        page: this.currentPage,
        size: this.pageSize,
        carNumber: this.CarNo,
        dataStartTime:
          this.date == null
            ? ""
            : this.date[0].format("yyyy-MM-dd"),
        dataEndTime:
          this.date == null
            ? ""
            : this.date[1].format("yyyy-MM-dd")
      };
      this.loading = true;
      CarParkFeeRecord(searchInfo)
        .then(r => {
          this.tableData = r.data || [];
          this.total = r.count || 0;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
          console.log(e);
          this.errmsg("服务异常，请联系管理员！");
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.CarNo = "";
      this.date = [new Date(), new Date()];
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  }
};
</script>
